import { FC, memo } from 'react';
import i18n from 'i18n';
import styles from './orderDetailInfo.module.scss';
import { Order } from 'core/order/Order';
import {
  BasicViewDataType,
  getBasicViewData,
  PerformanceViewDataType,
  getPerformanceViewData,
} from './OrderDetailInfoUtils';

const BasicDetailInfo: FC<{
  basicViewData: BasicViewDataType;
}> = ({ basicViewData }) => {
  return (
    <>
      {Object.entries(basicViewData).map(([key, { value, hint }]) => {
        const className = hint
          ? `${styles.fieldValue} ${styles.changeValue}`
          : styles.fieldValue;
        return (
          <div className={styles.field} key={key}>
            <div className={styles.fieldLabel}>
              {i18n.t<string>(`orderDetail.labels.${key}`)}
            </div>
            <div className={className}>{value}</div>
            <div className={styles.fieldHint}>{hint}</div>
          </div>
        );
      })}
    </>
  );
};

const PerformanceDetailInfo: FC<{
  performanceViewData: PerformanceViewDataType;
}> = ({ performanceViewData }) => {
  return (
    <>
      {Object.entries(performanceViewData).map(([key, { value }]) => (
        <div className={styles.field} key={key}>
          <div className={styles.fieldLabel}>
            {i18n.t<string>(`orderDetail.labels.${key}`)}
          </div>
          <div className={`${styles.fieldValue} ${styles.performanceField}`}>
            {value}
          </div>
        </div>
      ))}
    </>
  );
};

const OrderDetailInfo: FC<{
  order: Order;
}> = memo(({ order }) => {
  const basicViewData = getBasicViewData(order);
  const performanceViewData = getPerformanceViewData(order);
  return (
    <>
      <div className={styles.basic}>
        <BasicDetailInfo basicViewData={basicViewData} />
      </div>
      <div className={styles.sepLine} />
      <div className={styles.performance}>
        <PerformanceDetailInfo performanceViewData={performanceViewData} />
      </div>
    </>
  );
});

export default OrderDetailInfo;
